import React from 'react';
import { serverSideTranslations } from 'next-i18next/serverSideTranslations';
import { useTranslation } from 'next-i18next';
import { NAME as ACCOUNT_NAME } from '@app/account/constants';
import { NAME as MARKETING_NAME } from '@app/marketing/constants';
import { useRouter } from 'next/router';

// UI
import Subtitle from '@ui/components/Subtitle';
import ResetPasswordForm from '@app/account/components/ResetPasswordForm';
import Headline from '@ui/components/Headline';
import DefaultLayout from '@ui/layouts/Default.layout';
import MetaTags from '@ui/components/MetaTags';

// Types
import { NextPage } from 'next';

interface Props {}

export const ResetPasswordPage: NextPage<Props> = ({}) => {
    const { t } = useTranslation(ACCOUNT_NAME);
    const { locale, pathname } = useRouter();

    return (
        <>
            <MetaTags
                title={t('reset-password')}
                description={t('reset-password-description')}
                locale={locale}
                pathname={pathname}
            />

            <DefaultLayout>
                <div className="mx-auto mt-24 flex max-w-screen-lg flex-1 flex-col justify-center px-4 pb-24 sm:px-0">
                    <div className="text-center">
                        <Headline>{t('reset-password')}</Headline>
                        <Subtitle>{t('reset-password-description')}</Subtitle>
                    </div>

                    <ResetPasswordForm />
                </div>
            </DefaultLayout>
        </>
    );
};

export default ResetPasswordPage;

export const getStaticProps = async ({ locale }) => {
    return {
        props: {
            ...(await serverSideTranslations(locale, [MARKETING_NAME, ACCOUNT_NAME, 'common'])),
            // Will be passed to the page component as props
        },
    };
};
